<template>
  <!--  main div  -->
  <div class="d-flex flex-column flex">
    <div>
      <v-card height="100%">
        <v-card-title>
          Dashboard
          <v-spacer></v-spacer>
          <v-btn color="info" outlined depressed @click="closeAndLogin" v-if="isCleared" class="ml-4">Access Main Portal
          </v-btn>
        </v-card-title>
        <v-divider></v-divider>

        <v-card-text class="d-flex flex-column flex-md-row">
          <div class="mx-1-md-1 flex-grow-1" rounded v-if="getUser != null">
            <div class="d-flex flex-column flex-md-row ">
              <div class="px-2 mr-md-6 mx-auto">
                <v-alert type="error" class="mt-2" v-if="isMobile && getUser.programme != null && getUser.programme.programmeType.id !== getUser.yearOfAdmission.programmeType.id">
                  Consider having your admission details updated!!!
                </v-alert>
                <v-alert type="error" class="mt-2" v-if="isMobile && getNYSCDetails != null && !getNYSCDetails?.documentPath && getUser!= null && getUser.admission != null && getUser.admission.id > 69">
                  Consider uploading your nysc document!
                  <v-btn color="primary" @click="goToStep(4)">Proceed</v-btn>
                </v-alert>
                <v-img :width="isMobile ? '200' : '200'" aspect-ratio="1" class="img rounded mx-auto" :src="image"></v-img>
                <!-- upload button -->
                <v-btn color="primary" depressed class="mt-4" :width="isMobile ? '180' : '200'"
                  @click="showUploadPicture = true" v-if="canChangeImage">
                  Update photo
                </v-btn>

                <!--      resetting application        -->
                <reset-application v-if="showReset" class="mb-4"></reset-application>

              <!--       Phone number         -->
                <div class="d-flex flex-column mt-6" >
                  <v-alert :width="isMobile ? '200': '200'" type="warning" :class="{'w150': isMobile, 'w200': !isMobile, 'mx-auto': true}">
                    Update phone if there is a problem with payment
                  </v-alert>

                  <v-switch color="primary" label="Update phone" v-model="editPhone"></v-switch>


                  <transition name="update-phone">
                    <v-text-field
                      outlined dense
                      :class="{'w150': isMobile, 'w200': !isMobile}"
                      v-model="obj.phone"
                      placeholder="Phone number"
                      v-if="editPhone">
                    </v-text-field>

                  </transition>
                    <v-btn color="primary" depressed :width="isMobile ? '150' : '200'" v-if="editPhone"
                      @click="updatePhone">
                      Update phone
                    </v-btn>



                </div>
              </div>

              <div class="ml-md-5 mt-4 mt-md-0 px-10 flex-grow-1">
                <v-row dense class="mt-1">
                  <v-col sm="12" md="6">
                    <span class="basic--text font-weight-bold">Name</span>
                  </v-col>

                  <v-col sm="12" md="6" class="black--text font-weight-bold text-right">{{ getUser.name }}</v-col>
                </v-row>
                <v-divider class="my-4"></v-divider>
                <v-row dense class="mt-1">
                  <v-col sm="12" md="6"><span class="basic--text font-weight-bold">Applicant ID</span></v-col>
                  <v-col sm="12" md="6" class="black--text font-weight-bold text-right">{{ getUser.userId }}</v-col>
                </v-row>
                <v-divider class="my-4"></v-divider>
                <v-row dense>
                  <v-col sm="12" md="6"><span class="basic--text font-weight-bold">Phone</span></v-col>
                  <v-col sm="12" md="6" class="black--text font-weight-bold text-right">{{ getUser.phone }}</v-col>
                </v-row>
                <v-divider class="my-4"></v-divider>
                <v-row dense>
                  <v-col sm="12" md="6"><span class="basic--text font-weight-bold">Year of admission</span></v-col>
                  <v-col sm="12" md="6" class="black--text font-weight-bold text-right">{{ getUser.yearOfAdmission !=
                      null ? getUser.yearOfAdmission.name : ''
                  }}</v-col>
                </v-row>
                <v-divider class="my-4"></v-divider>
                <v-row dense>
                  <v-col sm="12" md="6"><span class="basic--text font-weight-bold">Programme Type</span></v-col>
                  <v-col sm="12" md="6" class="black--text font-weight-bold text-right">{{ getUser.yearOfAdmission !=
                      null ? getUser.yearOfAdmission.programmeType.name : ''
                  }}</v-col>
                </v-row>
                <v-divider class="my-4"></v-divider>
                <v-row dense>
                  <v-col sm="12" md="6"><span class="basic--text font-weight-bold">Faculty</span></v-col>
                  <v-col sm="12" md="6" class="black--text font-weight-bold text-right">{{ getUser.programme != null ?
                      getUser.programme.department.faculty.name : ''
                  }}</v-col>
                </v-row>
                <v-divider class="my-4"></v-divider>
                <v-row dense>
                  <v-col sm="12" md="6"><span class="basic--text font-weight-bold">Department</span></v-col>
                  <v-col sm="12" md="6" class="black--text font-weight-bold text-right">{{ getUser.programme != null ?
                      getUser.programme.department.name : ''
                  }}</v-col>
                </v-row>
                <v-divider class="my-4"></v-divider>
                <v-row dense>
                  <v-col sm="12" md="6"><span class="basic--text font-weight-bold">Programme</span></v-col>
                  <v-col sm="12" md="6" class="black--text font-weight-bold text-right">{{ getUser.programme != null ?
                      getUser.programme.name : ''
                  }}
                  </v-col>
                </v-row>
                <v-divider class="mt-4"></v-divider>
                <template
                  v-if="getUser.programme != null && getUser.programme.programmeType.modeOfEntryEnabled && getUser.modeOfEntry != null">
                  <v-row dense class="mt-4">
                    <v-col sm="12" md="6"><span class="basic--text font-weight-bold">Mode of entry</span></v-col>
                    <v-col sm="12" md="6" class="black--text font-weight-bold text-right">{{ getUser.modeOfEntry.title }}
                    </v-col>
                  </v-row>
                  <v-divider class="mt-4"></v-divider>
                </template>
              </div>

              <div :class="{'px-2 mt-md-4 mb-md-4 mr-md-4 ml-md-auto flex-shrink-0': true, 'w-pc30': !isMobile}"
                v-if="getUser != null">
                <v-alert type="error" v-if="!isMobile && getUser.programme != null && getUser.programme.programmeType.id !== getUser.yearOfAdmission.programmeType.id">
                  Consider having your admission details updated!!!
                </v-alert>
                <v-alert type="error" class="mt-2" v-if="!isMobile && getNYSCDetails != null && !getNYSCDetails?.documentPath && getUser!= null  && getUser.admission != null && getUser.admission.id > 69">
                  Consider uploading your nysc document!
                  <v-btn color="primary" @click="goToStep(4)">Proceed</v-btn>
                </v-alert>
                <v-timeline align-top dense>
                  <v-timeline-item color="green" small>
                    <v-row class="pt-1">
                      <v-col>
                        <strong>Admission</strong>
                        <div class="text-caption" style="word-break: break-all;">{{ getUser.admission.applicationType.name }}</div>
                      </v-col>
                    </v-row>
                  </v-timeline-item>

                  <v-timeline-item color="green" small>
                    <v-row class="pt-1">
                      <v-col>
                        <strong>Session</strong>
                        <div class="text-caption mb-2">
                          {{ getUser.admission.session.name }}
                        </div>
                      </v-col>
                    </v-row>
                  </v-timeline-item>

                  <v-timeline-item color="green" small>
                    <v-row class="pt-1">
                      <v-col>
                        <strong>Mode of study</strong>
                        <div class="text-caption">{{ getUser.admission.session.programmeType.modeOfStudy }}</div>
                      </v-col>
                    </v-row>
                  </v-timeline-item>

                  <v-timeline-item :color="getUser != null && getUser.cleared ? 'green' : 'red'" small>
                    <v-row class="pt-1">
                      <v-col>
                        <strong>Status</strong>
                        <div class="text-caption" style="word-break: break-all;" v-if="getUser.studentStatus === 'SCREENING_PENDING' && getUser.admission.applicationType.processPostUtme">
                          <div>
                            {{ getUser.studentStatus }}
                          </div>
                          <div>
                            Verification in progress, check back later.
                          </div>
                        </div>
                        <div class="text-caption" v-else style="word-break: break-all;">{{
                            getUser.studentStatus
                        }}</div>
                        <div style="word-break: break-all" class="text-caption" v-if="getUser.studentStatus === 'SCREENING_NOT_SUCCESSFUL' && getUser.screeningReason">
                          {{ getUser.screeningReason }}
                        </div>
                      </v-col>
                    </v-row>
                  </v-timeline-item>
                </v-timeline>

                <div class="d-flex justify-lg-space-around flex-column pa-6" v-if="canSeeAdmissionOption">
                  <v-alert v-if="admissionOfferExpired" type="error">
                    Your admission offer has expired. Contact the admissions office if you need assistance.
                  </v-alert>
                  <v-alert type="info">
                    You have been offered admission. Click the button below to continue
                  </v-alert>
                  <v-menu bottom left>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn color="primary" dark v-bind="attrs" v-on="on" depressed :disabled="loading">
                        More
                      </v-btn>
                    </template>

                    <v-list>
                      <v-list-item link @click="downloadInvoice">
                        <v-list-item-title>Download invoice</v-list-item-title>
                      </v-list-item>
                      <v-list-item link v-if="canAcceptOrReject" @click="processAcceptAdmission" :disabled="loading">
                        <v-list-item-title>Accept offer</v-list-item-title>
                      </v-list-item>

                      <v-list-item link v-if="canAcceptOrReject">
                        <v-list-item-title class="error--text" @click="showConfirmReject = true">Reject offer
                        </v-list-item-title>
                      </v-list-item>

                      <v-list-item link v-if="hasAcceptedAdmission" @click="downloadLetter">
                        <v-list-item-title>Download admission letter</v-list-item-title>
                      </v-list-item>
                    </v-list>
                  </v-menu>
                </div>
              </div>
            </div>
            <!-- <div v-else class="text-center font-weight-bold my-8 basic--text">No Data Loaded</div> -->
          </div>
        </v-card-text>
      </v-card>
    </div>

    <loading-dialog :show="loading"></loading-dialog>
    <message-box :show="messageShow" :message="message" :type="messageType"
      v-on:close-message="messageShow = !messageShow"></message-box>
    <!--  confirmation box for rejecting admission  -->
    <confirmation-box message="Are you sure you want to reject admission? This action can not be reversed"
      :show="showConfirmReject" v-on:positive="rejectAdmission" v-on:negative="showConfirmReject = false">
    </confirmation-box>
    <profile-picture-upload :show="showUploadPicture" v-on:close="showUploadPicture = !showUploadPicture"
      :user="getUser" v-on:uploaded="profilePictureUploaded"></profile-picture-upload>
  </div>

</template>


<script>
import Defaults from "@/shared/Defaults";
import { mapGetters } from "vuex";
import LoginUtil from "../../../../login/LoginUtil";
import StudentStatus from "@/shared/StudentStatus";
import MessageBox from '@ui/components/MessageBox';
import LoadingDialog from '@ui/components/LoadingDialog';
import ErrorResolver from '@/shared/ErrorResolver';
import Api from '@/main/api';
import ConfirmationBox from "@/components/ConfirmationBox";
import { PaymentGateway } from "@/shared/PaymentGateway";
import GateWays from "@/shared/GateWays";
import Links from "@/shared/constants/Links";
import ProfilePictureUpload from '../../../../components/ProfilePictureUpload.vue';
import ResetApplication from "@/application/components/ResetApplication";

export default {
  name: "Dashboard",
  components: {
    ResetApplication,
    ConfirmationBox,
    // eslint-disable-next-line vue/no-unused-components
    MessageBox,
    LoadingDialog,
    ProfilePictureUpload
  },

  data: () => ({
    items: [
      {
        color: 'red lighten-2',
        icon: 'mdi-star',
      },
      {
        color: 'purple darken-1',
        icon: 'mdi-book-variant',
      },
    ],

    image: '',
    messageType: '',
    message: '',
    messageShow: false,
    loading: false,
    showConfirmReject: false,
    paymentGateway: null,
    payment: null,
    paymentConfig: null,
    showUploadPicture: false,
    admissionOfferExpired: false,
    editPhone: false,
    obj: {
      phone: ''
    }
  }),


  methods: {
    rejectAdmission: function () {
      this.loading = true;

      Api.applicants.rejectAdmission(this.getUser.id).then(res => {
        this.messageShow = true;
        this.messageType = "success";
        this.message = "Admission rejected"
        this.$store.commit('setCurrentUser', res.data)
      }).catch((err) => {
        ErrorResolver.checkErrors(this, err);
      }).finally(() => {
        this.loading = this.showConfirmReject = false;
      })
    },

    processAcceptAdmission() {
      if (this.loading || this.admissionOfferExpired) return

      if (this.getUser != null) {
        if (this.getUser.admission.applicationType.admissionFee > 0.1) {
          this.initializePayment()
        } else {
          this.acceptAdmission();
        }
      }
    },

    profilePictureUploaded() {
      window.location.reload()
    },

    acceptAdmission() {
      this.loading = true
      Api.applicants.acceptAdmission(this.getUser.id)
        .then(res => {
          this.message = 'Admission accepted'
          this.messageType = 'success'
          this.messageShow = true
          this.$store.commit('setCurrentUser', res.data)
        }).catch(err => {
          const response = err.response
          const responseMessage = response?.data?.message

          if (response?.status === 422 && responseMessage === 'Admission offer has expired') {
            this.admissionOfferExpired = true
            this.message = 'Your admission offer has expired.'
            this.messageType = 'error'
            this.messageShow = true
            return
          }

          ErrorResolver.checkErrors(this, err)
        })
        .finally(() => this.loading = false)
    },

    updatePhone() {
      this.loading = true
      Api.applicants.updatePhone(this.getUser.id, this.obj)
          .then(res => {
            this.message = 'Phone number updated'
            this.messageType = 'success'
            this.messageShow = true
            this.$store.commit('setCurrentUser', res.data)
          }).catch(err => ErrorResolver.checkErrors(this, err))
          .finally(() => {
            this.loading = false
            this.editPhone = false
          })
    },

    downloadInvoice() {
      this.loading = true;
      Api.applicants.acceptanceInvoice(this.getUser.id)
        .then(res => {
          let fileURL = window.URL.createObjectURL(new Blob([res.data], { type: 'application/pdf' }));
          let fileLink = document.createElement('a');

          fileLink.href = fileURL;
          fileLink.setAttribute('download', 'invoice.pdf');
          document.body.appendChild(fileLink);

            fileLink.click();
            fileLink.remove();
          }).catch(() => {
        // ErrorReslover.checkErrors(this, err);
          this.message = "Failed to Download Invoice"
          this.messageType = "error"
          this.messageShow = true
      }).finally(() => this.loading = false)
    },

    downloadLetter() {
      this.loading = true;
      Api.admission.getLetter(this.getUser.userId)
        .then(res => {
          let fileURL = window.URL.createObjectURL(new Blob([res.data], { type: 'application/pdf' }));
          let fileLink = document.createElement('a');

          fileLink.href = fileURL;
          fileLink.setAttribute('download', 'admission.pdf');
          document.body.appendChild(fileLink);

            fileLink.click();
            fileLink.remove();
          }).catch(err => {
        ErrorResolver.checkErrors(this, err);
      }).finally(() => this.loading = false)
    },

    initializePayment() {
      // initialize and get invoice
      this.loading = true
      Api.applicants.initializeAcceptanceFeeTransaction(this.getUser.id)
        .then(res => {
          this.payment = res.data
          // show alert and make payment
          this.message = 'Initialized'
          this.messageType = 'success'
          this.messageShow = true
          this.makePayment()
        }).catch(err => ErrorResolver.checkErrors(this, err))
        .finally(() => this.loading = false)
    },

    makePayment() {
      if (this.payment != null) {
        // _^-^_ always check for inline first
        if (this.paymentConfig.inline) {
          // do this
          this.paymentGateway.makePayment({
            email: this.getUser.email,
            amount: this.getUser.admission.applicationType.admissionFee,
            currency: 'NGN',
            invoice: this.payment.transactionId,
            paymentId: this.payment.id
          }, () => {
            window.location.reload()
          }, (invoice) => {
            // process
            this.loading = true
            Api.payment.processInline(invoice)
                .then(() => {
                  window.location.href = "/application"
                }).catch(err => {
              ErrorResolver.checkErrors(this, err)
              this.loading = false
            })
          })
        } else {
          // payment should not be done inline
          // open windwo for payment
          this.loading = true
          window.location.href = this.payment.paymentLink
        }
      }
    },

    goToStep(step) {
      this.$router.push({ path: `/application?step=${step}` })
    },

    async logout() {
      // End the session server-side. Swallow errors: if the token is
      // already invalid the call may 401 — we still clear locally.
      try {
        await Api.auth.logout();
      } catch (e) {
        // ignore — local cleanup below is what matters
      }
      LoginUtil.resetAccessToken();
      LoginUtil.resetRefreshToken();
      // this.$store.commit("setCurrentUser", {user: null, superOption: false});
      this.$store.commit("setInformation", null);
      window.location.reload();
    },

    closeAndLogin() {
      window.location.href = '/student'
    },

  },

  watch: {
    getUser: function (val) {
      if (val != null) {
        this.image = Defaults.api + '/profile-picture/fetch?user=' + this.getUser.userId;
        this.obj.phone = val.phone
      }
    }
  },

  computed: {
    isMobile: function () {
      return this.$vuetify.breakpoint.smAndDown
    },

    canSeeAdmissionOption() {
      return this.getUser != null && StudentStatus[this.getUser.studentStatus].value === StudentStatus.ADMISSION_OFFERED.value
        || StudentStatus[this.getUser.studentStatus].value === StudentStatus.ADMISSION_ACCEPTED.value || this.getUser.studentStatus === StudentStatus.CLEARED.text
        || this.getUser.studentStatus === StudentStatus.STUDENT.text;
    },

    canChangeImage(){
      return this.getUser != null && StudentStatus[this.getUser.studentStatus].value < StudentStatus.STUDENT.value
    },

    canAcceptOrReject() {
      return this.getUser != null &&
        !this.admissionOfferExpired &&
        this.getUser.studentStatus === StudentStatus.ADMISSION_OFFERED.text;
    },

    hasAcceptedAdmission: function () {
      return this.getUser != null &&
        (this.getUser.studentStatus === StudentStatus.ADMISSION_ACCEPTED.text || this.getUser.studentStatus === StudentStatus.CLEARED.text
          || this.getUser.studentStatus === StudentStatus.STUDENT.text);
    },

    isCleared: function () {
      return this.getUser != null && (this.getUser.cleared || this.getUser.studentStatus === StudentStatus.ADMISSION_ACCEPTED.text || this.getUser.yearOfAdmission?.programmeType?.studentDashboardAccessStatus === this.getUser.studentStatus);
    },

    showReset: function(){
      return this.getUser != null && StudentStatus[this.getUser.studentStatus].value <= StudentStatus.SCREENING_NOT_SUCCESSFUL.value
    },

    canUploadPicture: function () {
      return this.getUser != null && this.getUser.profilePicture == null;
    },

    ...mapGetters(['getUser', "getNYSCDetails"])
  },

  mounted() {
    // initialize gateway
    this.$nextTick(() => {
      this.paymentGateway = new PaymentGateway(GateWays.PAYSTACK, this, Links.payments.processInlinePayment)
      Api.paymentPlatforms.getActive()
        .then(res => {
          if (this.paymentGateway != null) {
            // set config
            this.paymentConfig = res.data
            // if inline, initialize
            if (res.data.inline)
              this.paymentGateway.initializeGateway(res.data)
          } else {
            this.message = 'No payment settings found'
            this.messageType = 'error'
            this.messageShow = true
          }
        }).catch(err => ErrorResolver.checkErrors(this, err))
    })
  },

  created() {
    if (!LoginUtil.getAccessToken() && !LoginUtil.getRefreshToken()) { // not logged in
      this.$router.push('/')
      return;
    }

    if (this.getUser != null) {
      this.image = Defaults.api + '/profile-picture/fetch?user=' + this.getUser.userId;
      this.obj.phone = this.getUser.phone
    }
  }
}
</script>



<style lang="css" scoped>

/** enter and leave animation for the toggle and input of phone number */
.update-phone-enter-active {
  transition: all 0.3s ease-out;
}

.update-phone-leave-active {
  transition: all 0.8s cubic-bezier(1, 0.5, 0.8, 1);
}

.update-phone-enter-from,
.update-phone-leave-to {
  transform: translateX(20px);
  opacity: 0;
}


@media only screen and (width: 768px) and (height: 1024px) {
  img {
    background-color: red;
  }
}

.w-pc30{
  width: 30%;
}

.w150{
  width: 150px;
}

.w200{
  width: 200px;
}
</style>
